import { combineReducers } from 'redux';
import searchReducer from './searchReducer';
import resultsReducer from '../../search/reducers/resultsReducer';

export const reducers = combineReducers({
  search: searchReducer,
  results: resultsReducer,
});
